import { Node_Type } from './../ricos-schema/legacy/wix/rich_content/v1';

export const verticalEmbedProviders = {
  event: 'event',
  booking: 'booking',
  product: 'product',
} as const;

export const contentTypeMap = {
  EVENT: 'Events',
  BOOKING: 'Bookings',
  PRODUCT: 'Stores',
  UNRECOGNIZED: 'Events',
} as const;

export type ContentType = (typeof contentTypeMap)[keyof typeof contentTypeMap];

export const verticalEmbedModals = {
  insertBooking: `${Node_Type.APP_EMBED}.insertBooking`,
  insertProduct: `${Node_Type.APP_EMBED}.insertProduct`,
  insertEvent: `${Node_Type.APP_EMBED}.insertEvent`,
  replace: `${Node_Type.APP_EMBED}.replace`,
};
